// The owner's toast when animals walking over the fields trampled crops (server herd loop,
// farm_changed by 'herd'): growth was set back a little (owner 2026-10-01).
const WHO = { krowa: ['Krowa', '{cow}'], kura: ['Kura', '{chicken}'] };
const plural = (n, one, few, many) => (n === 1 ? one : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? few : many);

export function trampleToast(trampled, crops = {}) {
  if (!trampled?.length) return null;
  if (trampled.length > 1) {
    return `Zwierzęta podeptały ${trampled.length} ${plural(trampled.length, 'grządkę', 'grządki', 'grządek')} — urosną trochę później`;
  }
  const [t] = trampled;
  const [who, icon] = WHO[t.species] ?? ['Zwierzę', ''];
  const name = crops[t.seed]?.name_pl ?? 'grządka';
  return `${who} podeptała grządkę: ${name}${icon ? ` ${icon}` : ''} — urośnie trochę później`;
}
